<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="form-floating" :style="error.meno ? 'border: 1px solid red;' : ''">
                <input v-model="user.meno" type="text" class="form-control" id="floatingMeno"
                    :placeholder="$t('companyuser.text_6')">
                <label for="floatingMeno">{{ $t('companyusers.text_6') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="form-floating" :style="error.priezvisko ? 'border: 1px solid red;' : ''">
                <input v-model="user.priezvisko" type="text" class="form-control" id="floatingPriezvisko"
                    :placeholder="$t('companyusers.text_7')">
                <label for="floatingPriezvisko">{{ $t('companyusers.text_7') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="form-floating" :style="error.email ? 'border: 1px solid red;' : ''">
                <input v-model="user.email" type="text" class="form-control" id="floatingEmail"
                    :placeholder="$t('companyusers.text_8')">
                <label for="floatingEmail">{{ $t('companyusers.text_8') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="form-floating" :style="error.heslo ? 'border: 1px solid red;' : ''">
                <input v-model="user.heslo" type="password" class="form-control" id="floatingHeslo"
                    :placeholder="$t('companyusers.text_9')">
                <label for="floatingHeslo">{{ $t('companyusers.text_9') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="access_box">
                <h6>Prístupy</h6>
                <div class="form-group mb-3 mt-2 mobile_doba_inputs" data-click="no">
                    <div class="d-flex" data-click="no">
                        <input v-model="option2" type="checkbox" class="toggle" data-click="no">
                        <label class="block mb-0 mt-1" @click="option2 = !option2" style="cursor:pointer;"
                            data-click="no">
                            Používateľ vidí ponuky vytvorené mnou (vlastníkom teamu)
                        </label>
                    </div>
                </div>
                <div class="form-group mb-3 mt-2 mobile_doba_inputs" data-click="no">
                    <div class="d-flex" data-click="no">
                        <input v-model="option1" type="checkbox" class="toggle" data-click="no">
                        <label class="block mb-0 mt-1" @click="option1 = !option1" style="cursor:pointer;"
                            data-click="no">
                            Používateľ vidí ponuky vytvorené inými členmi tímu
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="is_paid" class="col-xl-12">
            <div class="btns">
                <div :class="edited ? 'create_btn' : 'create_btn active'" @click="create">
                    {{ edited ? $t('companyusers.text_10') : $t('companyusers.text_11') }}
                </div>
                <div v-show="edited" @click="$emit('stop')" class="cancel_btn">
                    {{ $t('companyusers.text_12') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data', 'is_paid', 'max_users_reached'],
    data() {
        return {
            option1: false,
            option2: false,
            user: {
                meno: "",
                priezvisko: "",
                email: "",
                heslo: "",
                access_option: 0,
            },
            error: {}
        }
    },
    methods: {
        create() {
            if(this.max_users_reached){
                this.$emit('showMaxUsersModal')
                return;
            }
            this.error = {}
            if (this.user.email == "")
                this.error['email'] = true
            if (!this.edited) {
                if (this.user.heslo == "")
                    this.error['heslo'] = true
            }
            // this.user.access_option = 0 -> only yours offers
            // this.user.access_option = 1 -> yours and sub-users offers | option1 -> sub-users offers
            // this.user.access_option = 2 -> yours and owner offers | option2 -> owner offers
            // this.user.access_option = 3 -> all offers
            this.user.access_option = this.option1 && this.option2 ? 3 : this.option2 ? 2 : this.option1 ? 1 : 0;
            if (Object.keys(this.error).length == 0) {
                this.$emit('create', this.user)
                this.$emit('stop')
            }
        }
    },
    computed: {
        edited() {
            if (Object.keys(this.data).length != 0) {
                return true
            }
            else {
                this.user = {
                    meno: "",
                    priezvisko: "",
                    email: "",
                    heslo: ""
                }
                return false
            }
        }
    },
    watch: {
        data: function () {
            this.error = {}
            this.user = this.data
            if (this.data.access_option == 3) {
                this.option1 = true
                this.option2 = true
            }
            else if (this.data.access_option == 2) {
                this.option1 = false
                this.option2 = true
            }
            else if (this.data.access_option == 1) {
                this.option1 = true
                this.option2 = false
            }
            else {
                this.option1 = false
                this.option2 = false
            }
        }
    },
}
</script>
<style lang="scss">
.select_review {
    .v-input__slot {
        border: 1px solid #ced4da;
        box-shadow: none !important;
    }

    .v-text-field__details {
        margin-bottom: 0 !important;
    }

    .v-icon.v-icon {
        font-size: 14px !important;
    }
}
</style>
<style lang="scss" scoped>
.access_box {
    background-color: #fff;
    padding: 10px;
    width: 100%;
    border-radius: 10px;
    margin: 0 auto;
    border: 1px solid #DDE3E8;
    @media only screen and (max-width: 600px) {
        width: 90%;
    }

    h6 {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #212541;
        margin-bottom: 20px;
    }
}

.row {
    width: 474px;

    @media only screen and (max-width: 600px) {
        width: 90%;
    }

    margin: 0 auto;
    padding: 0;

    .form-floating {
        border-radius: 4px;

        input {
            display: flex !important;
            align-items: center !important;
            background: #FFFFFF;
            border: 1px solid #DDE3E8;
            box-sizing: border-box;
            font-family: Roboto;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }

        label {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 12px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }

        textarea {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
    }
}

.btns {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 200px;
        height: 55px;
        box-sizing: border-box;
        border-radius: 4px;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #FFFFFF;

        &.cancel_btn {
            background: #F3385A;
        }

        &.create_btn {
            background: #2ED8B6;
        }

        &.create_btn.active {
            width: 100%;
        }
    }
}

label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #C7D4EB;
    border-radius: 25px;
}

.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #FFFFFF;
    border-radius: 3px;
    transition: all 0.2s ease;

    &:focus {
        outline: 0;
    }

    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }

    &:checked {
        border-color: #2ED8B6;
        background: #2ED8B6;
    }

    &:disabled {
        background: #2ED8B6;
        opacity: 0.4;
        cursor: not-allowed;
    }

    &:checked:after {
        transform: translatex(20px);

    }
}
</style>